import { styled } from 'baseui';
import React from 'react';
const Link = styled('a', ({
  $theme
}) => ({
  color: $theme.colors.accent
}));
const RequiredAsterisk = styled('span', ({
  $theme
}) => ({
  color: $theme.colors.negative
}));
const defaultQuestionDecorator = (href: string, text: string, key: number) => <Link href={href} key={key} target="_blank" rel="noopener noreferrer">
    {text}
  </Link>;
const defaultRequiredHintRenderer = isRequired => {
  return <>{isRequired ? <RequiredAsterisk>*</RequiredAsterisk> : ''}</>;
};
export const defaultQuestionStyles: {
  questionDecorator: (href: string, text: string, key: number) => JSX.Element;
  requiredHintRenderer: (isRequired?: boolean) => JSX.Element;
  defaultTagVisibility: boolean;
  questionTitleStyles?: Record<string, string | number>;
  answerTextStyles?: Record<string, string | number>;
} = {
  questionDecorator: defaultQuestionDecorator,
  requiredHintRenderer: defaultRequiredHintRenderer,
  defaultTagVisibility: false,
  questionTitleStyles: undefined,
  answerTextStyles: undefined
};
export const QuestionStyleContext = React.createContext(defaultQuestionStyles);
export default {
  defaultQuestionStyles,
  QuestionStyleContext
};